export enum ECustomerReportSettingType {
  EVERYDAY = 1,
  EVERYWEEK = 2,
}

export enum ECustomerReportSettingPeriodType {
  WEEKLY = 1,
  MONTH_TO_DATE = 2,
}
